export default __webpack_public_path__ + "img/heart.965c58b6.svg";